Gift = require '../../gift_button/frontend/gift'

MODAL_OFFSET = {left: 112, top: -130}
GIFT_MODAL_OFFSET = {left: 60, top: -145}
OFFERS_MODAL_OFFSET = {left: 136, top: -118}
TABLET_MQ_WIDTH = 768

window.MultiOptionModal ?= {}

MultiOptionModal.init = (payload, done) ->
  return done() unless payload?.buyButton.multiOptionEnabled

  openMultiOptionModal = (e) ->
    e?.preventDefault()
    # TODO: add an experiment that smoothly scrolls to the title,
    # instead of suddenly jumping to the top
    # scrollAmount = $("section.deal").offset().top

    # $('html, body').animate
    #  scrollTop: scrollAmount

    modalSelector = if BuyButton.view.offersClicked then '#offer-options' else '#options'
    $modal = $ modalSelector
    return unless $modal.length

    if $modal.hasClass 'tooltip'
      $otherTooltip = if modalSelector is '#options'
        $ '#offer-options'
      else
        $ '#options'

      if $otherTooltip.is ':visible'
        $otherTooltip.find('.tooltip-close').click()

      $tooltipTrigger = if BuyButton.view.offersClicked
        $ '.offer-buy-button'
      else if Gift.cookieCreated
        $ '.gift-button'
      else
        $ '.buy-button'

      $tooltipTrigger.attr
        'data-position': 'bottom'
        'data-tooltip-id': modalSelector.slice 1
        'data-trigger-event': 'js-trigger'

      $tooltipTrigger.find('.tooltip-target').attr('data-position', 'bottom')

      GIG.Tooltip.helpers.tooltip.apply $tooltipTrigger[0], [{preventDefault: ->}]

    else
      return if $modal.hasClass 'show-modal'
      return if  $(".header-row-sticky").is(":visible") and not payload.buyButton.multiOptionInline

      unless BuyButton.view.$multiOptions.filter('.selected').length
        firstAvailableOption = BuyButton.view.$multiOptions.not((i, el) -> $(el).parents('.multi-option-overlay-item-disabled').length)[0]
        BuyButton.view.updateMultiOptionBreakoutButton currentTarget: firstAvailableOption

      GIG.Modal.open(el: $modal)

    {stopTheBus: true}

  if payload.buyButton.multiOptionInline
    BuyButton.eventBus.board('view_options_clicked', openMultiOptionModal)
  else
    BuyButton.eventBus.board('buy_button_clicked', openMultiOptionModal)(998)

  $ ->
    $triggers = $(".show-multi-option-modal")
    $triggers.click openMultiOptionModal
    $body = $(document.body)

    GIG.Modal.onClose Gift.removeCookie, 'options'
    GIG.Modal.onClose Gift.removeCookie, 'offer-options'


    $('#options, #offer-options').on 'click', '.tooltip-close', Gift.removeCookie

    done()


module.exports = MultiOptionModal
